import { put, call, takeEvery, select } from 'redux-saga/effects'

import { companyId } from '@/core/selectors/sessions'

import * as hiringAnalyticsView from '../reducks/hiringAnalytics'
import { getRates } from '@/core/apiModules/hiringAnalytics'
import { errorHandler } from '@/core/helpers/errorHelpers'
import { showSystemError, hideSystemError } from '@/core/components/SystemErrorRedux'

function* fetchRates() {
  try {
    yield put(hideSystemError())

    const id = yield select(companyId)
    const response = yield call(getRates, id, {
      rate: 'interview_request_to_hire',
    })
    yield put(hiringAnalyticsView.fetchRatesSuccess(response))
  } catch (err) {
    const { error } = yield call(errorHandler, err)
    yield put(hiringAnalyticsView.fetchRatesError(error))

    yield put(showSystemError(error))
  }
}

export default function* watchRatesSaga() {
  yield takeEvery(hiringAnalyticsView.FETCH_RATES, fetchRates)
}
